module.exports = __webpack_public_path__ + "img/palette-2-fg_cn.11e644e.jpg";